if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.handleProductCardSwatchClick();
      this.clickEvent();
    }

    fetchProduct(event, media) {
      event.preventDefault();

      media.classList.add("js-load");

      fetch(event.currentTarget.dataset.product + "?view=card-product--swatches")
        .then(response => response.text())
        .then(text => {
          const newHtml = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("product-card").innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;

            this.handleProductCardSwatchClick();
          }
        })
        .catch((e) => console.error(e))
        .finally(() => media.classList.remove("js-load"));
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll(".js-swatch");
      const media = this.querySelector(".js-card-media");

      swatches.forEach(swatch => {
        swatch.addEventListener("click", event => this.fetchProduct(event, media));
      });
    }

    clickEvent() {
      this.addEventListener("click", () => {
        const card = this.querySelector(".card");

        card.classList.add("card--active");
      });
    }
  }

  customElements.define("product-card", ProductCard);
}
